import moment from 'moment';

export default {
    methods: {
        dateFormat(value, format) {
            return value ? moment(value).format(format) : '';
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/dateFormat.js